export default __webpack_public_path__ + "static/media/ProximaNova-Alt-Thin.2f1b1383.otf";